import { InsInsightOutcomeResponse } from '@plato/data/prisma';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import type { BadgeProps } from '../../list-views/components/badge.tsx';

export const useInsightOutcomeResponseLabel = (response: InsInsightOutcomeResponse): string | null => {
    const { t } = useLocale('insights');

    switch (response) {
        case InsInsightOutcomeResponse.INTERESTED:
            return t('insight_outcome__response_INTERESTED');
        case InsInsightOutcomeResponse.NO_NEED:
            return t('insight_outcome__response_NO_NEED');
        case InsInsightOutcomeResponse.BUYS_ELSEWHERE:
            return t('insight_outcome__response_BUYS_ELSEWHERE');
        // INCORRECT and NORMAL belong to NOT_RELEVANT outcomes which are not shown in the app.
        case InsInsightOutcomeResponse.INCORRECT:
        case InsInsightOutcomeResponse.NORMAL:
            return null;
    }
};

export const getInsightOutcomeStatusColor = (response: InsInsightOutcomeResponse): BadgeProps['color'] => {
    switch (response) {
        case InsInsightOutcomeResponse.INTERESTED:
            return 'blue';
        case InsInsightOutcomeResponse.BUYS_ELSEWHERE:
            return 'orange';
        case InsInsightOutcomeResponse.NO_NEED:
            return 'neutral';
    }
};
